import { useContext, useRef, useEffect } from "react";
import { Footer } from "./layouts/Footer";
import Header from "./layouts/Header"
import { DataProvider } from "./store/ContextProvider";
import Router from "./Router";
import { useLocation } from "react-router-dom";
import Loading from "./pages/Loading";
import MaintenanceScreen from './components/StatusMessage'
import ResumePopUp from "./components/ResumePopUp";

function App() {
  const location = useLocation();


  const { showResume, isAuth, currentUser, loading, popup, handlePopupConfirm, handlePopupCancel, maintenanceMode } = useContext(DataProvider)
  const dialogRef = useRef();

  const renderPath = (path) => {
    const authPaths = [
      "/login",
      "/signup",
      "/forgotpassword",
      "/resetpassword",
      "/update-account/personalInformation",
      "/update-account/profilesummery",
      "/update-account/experience",
      "/update-account/education",
      "/update-account/skills",
      "/update-account/preferences",
      "/update-account/highlights",
      "/update-account/success",
    ];
    return authPaths.includes(path);
  };

  useEffect(() => {
    if (popup.visible) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [popup.visible]);

  if (isAuth == null || !currentUser || loading) {
    return <Loading />
  }

  if (maintenanceMode) return <MaintenanceScreen />
  return (
    <div className="relative bg-[#f8f8f8] mx-auto">
      <div className={`${(!renderPath(location.pathname) && isAuth) && "px-2 max-w-7xl mx-auto"}`}>
        {!renderPath(location.pathname) && <Header />}
        <Router />
      </div>
      {!renderPath(location.pathname) && <Footer />}

      {showResume && <ResumePopUp />}
      {/*Global Popup Dialog */}
      <dialog
        ref={dialogRef}
        className="rounded-lg p-6 max-w-md w-full backdrop:bg-black/30 bg-white shadow-xl"
      >
        <p className="text-gray-800 mb-4 text-base">{popup?.message || ""}</p>

        {popup?.type === 'alert' ? (
          <div className="text-center">
            <button
              onClick={handlePopupConfirm}
              className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md"
            >
              OK
            </button>
          </div>
        ) : (
          <div className="flex justify-end gap-4">
            <button
              onClick={handlePopupCancel}
              className="px-4 py-2 bg-secondary-700 hover:bg-secondary-800 text-white rounded"
            >
              Cancel
            </button>
            <button
              onClick={handlePopupConfirm}
              className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded"
            >
              OK
            </button>
          </div>
        )}
      </dialog>
    </div>
  );
}

export default App;
